import { render, staticRenderFns } from "./CouponDescPopup.vue?vue&type=template&id=421770b6&scoped=true"
import script from "./CouponDescPopup.vue?vue&type=script&lang=js"
export * from "./CouponDescPopup.vue?vue&type=script&lang=js"
import style0 from "./CouponDescPopup.vue?vue&type=style&index=0&id=421770b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421770b6",
  null
  
)

export default component.exports